export default "__VITE_ASSET__BkUTkXVu__"